import fs from "fs";
import path from "path";

import SysError from "../backend/errors/SysError.js";

//Util
import {
  fn_agruparTotal,
  fn_calcularTotal,
  fn_getChaveMaiorValor,
  fn_removerCaracteresInvalidosNomeArquivo,
} from "./utils/util.js";
import {
  ID_TIPO_NOTIFICACAO,
  SITUACAO_PAGAMENTO,
  SITUACAO_SOLICITACAO,
  TIPO_ANEXO_SOLICITACAO,
  TIPO_APROPRIACAO,
  TIPO_CENTRO_CUSTO,
  TIPO_CONTA_BANCARIA,
  TIPO_FILIAL,
  TIPO_INTEGRACAO,
  TIPO_PAGAMENTO,
  TIPO_PERFIL,
  TIPO_SOLICITACAO,
  SIGLA_FORMA_PAGAMENTO,
  TIPO_RATEIO,
  FORMA_RATEIO,
  TIPO_VENCIMENTO,
  TIPO_VALOR_PAG,
  TIPO_CONTA,
  POLITICA_SALARIAL,
  SITUACAO_REAJUSTE,
  TIPO_APROVACAO_SOL,
  SITUACAO_CONTRATO,
  TIPO_PERIOD_REAJUSTE,
  SITUACAO_APROVACAO,
  TIPO_FERIADO,
  TIPO_USUARIO,
  TIPO_CHAVE_PIX,
  TIPO_APURACAO,
  TIPO_LANCAMENTO_CONTRATO,
  CODIGO_FORNECEDOR_NAO_IDENTIFICADO,
  ID_FORNECEDOR_NAO_IDENTIFICADO,
  TIPO_VALOR,
  TIPO_ANEXO_PAGAMENTO,
  SITUACAO_CONFERENCIA,
  TIPO_GRUPO_CONTA,
  CAMPO_CONTRATO,
  ID_USUARIO_SYSTEM,
} from "./constantes.js";
import {
  fn_addMonth,
  fn_dataIsAfter,
  fn_dataIsBefore,
  fn_getDataHoraAtualSemSegundos,
  fn_getMesAnoAtual,
  fn_getMesAnoData,
  fn_validarMesAno,
} from "./utils/date.js";

const opcoesSituacao = [
  { value: "A", label: "Ativo" },
  { value: "I", label: "Inativo" },
];

const opcoesSituacaoContrato = [
  { value: SITUACAO_CONTRATO.ATIVO, label: "Ativo", className: "text-success" },
  {
    value: SITUACAO_CONTRATO.SUSPENSO,
    label: "Suspenso",
    className: "text-danger",
  },
  {
    value: SITUACAO_CONTRATO.RESCINDIDO,
    label: "Rescindido",
    className: "text-danger",
  },
  {
    value: SITUACAO_CONTRATO.CANCELADO,
    label: "Cancelado",
    className: "text-danger",
  },
];

const opcoesSituacaoSolicitacao = [
  {
    value: SITUACAO_SOLICITACAO.PENDENTE,
    label: "Pendente",
    className: "text-pendente",
  },
  {
    value: SITUACAO_SOLICITACAO.PENDENTE_REAPROVACAO,
    label: "Pendente reaprovação",
    className: "text-atencao",
  },
  { value: SITUACAO_SOLICITACAO.CONTROLE, label: "Controle", className: "" },
  {
    value: SITUACAO_SOLICITACAO.APROVADA,
    label: "Aprovada",
    className: "text-success",
  },
  {
    value: SITUACAO_SOLICITACAO.REJEITADA,
    label: "Rejeitada",
    className: "text-danger",
  },
  {
    value: SITUACAO_SOLICITACAO.REJEITADA_REAPROVACAO,
    label: "Rejeitada reaprovação",
    className: "text-danger",
  },
  {
    value: SITUACAO_SOLICITACAO.CANCELADA,
    label: "Cancelada",
    className: "text-danger",
  },
];

const opcoesSituacaoPagamento = [
  {
    value: SITUACAO_PAGAMENTO.PENDENTE,
    label: "Pendente",
    className: "text-pendente",
  },
  {
    value: SITUACAO_PAGAMENTO.PENDENTE_REAPROVACAO,
    label: "Pendente reaprovação",
    className: "text-atencao",
  },
  { value: SITUACAO_PAGAMENTO.CONTROLE, label: "Controle", className: "" },
  {
    value: SITUACAO_PAGAMENTO.CONFERIDO,
    label: "Conferido",
    className: "text-success",
  },
  {
    value: SITUACAO_PAGAMENTO.ERRO,
    label: "Erro",
    className: "text-danger",
  },
  // {
  //   value: SITUACAO_PAGAMENTO.REJEITADO,
  //   label: "Rejeitado",
  //   className: "text-danger",
  // },
  {
    value: SITUACAO_PAGAMENTO.REJEITADA_REAPROVACAO,
    label: "Rejeitada reaprovação",
    className: "text-danger",
  },
  {
    value: SITUACAO_PAGAMENTO.SUSPENSO,
    label: "Suspenso",
    className: "text-danger",
  },
  {
    value: SITUACAO_PAGAMENTO.CANCELADO,
    label: "Cancelado",
    className: "text-danger",
  },
];

const opcoesSituacaoAprovacao = [
  {
    value: SITUACAO_APROVACAO.PENDENTE,
    label: "Pendente",
    className: "text-pendente",
  },
  {
    value: SITUACAO_APROVACAO.APROVADA,
    label: "Aprovada",
    className: "text-success",
  },
  {
    value: SITUACAO_APROVACAO.REJEITADA,
    label: "Rejeitada",
    className: "text-danger",
  },
];

const opcoesSituacaoConferencia = [
  {
    value: SITUACAO_CONFERENCIA.CONFERIDO,
    label: "Conferido",
    className: "text-success",
  },
  {
    value: SITUACAO_CONFERENCIA.ERRO,
    label: "Erro",
    className: "text-danger",
  },
  {
    value: SITUACAO_CONFERENCIA.CANCELADA,
    label: "Cancelada",
    className: "text-danger",
  },
];

const opcoesSituacaoReajuste = [
  {
    value: SITUACAO_REAJUSTE.PENDENTE_APROVACAO,
    label: "Pendente aprovação",
    className: "text-atencao",
  },
  {
    value: SITUACAO_REAJUSTE.APROVADO,
    label: "Aprovado",
    className: "text-success",
  },
  {
    value: SITUACAO_REAJUSTE.REJEITADO,
    label: "Rejeitado",
    className: "text-danger",
  },
];

const opcoesTipoPerfil = [
  { value: TIPO_PERFIL.SYSTEM, label: "System", permite_criar: "N" },
  {
    value: TIPO_PERFIL.ADMINISTRATIVO,
    label: "Administrativo",
    permite_criar: "S",
  },
  { value: TIPO_PERFIL.LOJA, label: "Loja", permite_criar: "S" },
];

const opcoesTipoUsuario = [
  {
    value: TIPO_USUARIO.SYSTEM,
    label: "System",
    abreviatura: "Sys",
    permite_criar: "N",
  },
  {
    value: TIPO_USUARIO.ADMINISTRATIVO,
    label: "Administrativo",
    abreviatura: "Adm",
    permite_criar: "S",
  },
  {
    value: TIPO_USUARIO.LOJA,
    label: "Loja",
    abreviatura: "Loja",
    permite_criar: "S",
  },
];

const opcoesTipoPessoa = [
  { value: "J", label: "Jurídica" },
  { value: "F", label: "Física" },
];

const opcoesTipoFilial = [
  {
    value: TIPO_FILIAL.ADMINISTRATIVA,
    label: "Administrativa",
    abreviatura: "Adm",
  },
  {
    value: TIPO_FILIAL.CENTRO_DISTRIBUICAO,
    label: "Centro distribuição",
    abreviatura: "CD",
  },
  {
    value: TIPO_FILIAL.LOJA,
    label: "Loja",
    abreviatura: "Loja",
  },
];

const opcoesTipoCentroCusto = [
  {
    value: TIPO_CENTRO_CUSTO.LOJA,
    label: "Loja",
    abreviatura: "Loja",
    permite_criar: "N",
  },
  {
    value: TIPO_CENTRO_CUSTO.ADMINISTRATIVO,
    label: "Administrativo",
    abreviatura: "Adm",
    permite_criar: "S",
  },
  {
    value: TIPO_CENTRO_CUSTO.CENTRO_DISTRIBUICAO,
    label: "Centro distribuição",
    abreviatura: "CD",
    permite_criar: "S",
  },

  {
    value: TIPO_CENTRO_CUSTO.PAGAMENTO,
    label: "Pagamento",
    abreviatura: "Pag",
    permite_criar: "S",
  },
];

const opcoesTipoFeriado = [
  { value: TIPO_FERIADO.NACIONAL, label: "Nacional" },
  { value: TIPO_FERIADO.ESTADUAL, label: "Estadual" },
  { value: TIPO_FERIADO.MUNICIPAL, label: "Municipal" },
];

const opcoesTipoSolicitacao = [
  { value: TIPO_SOLICITACAO.PAGAMENTO, label: "Pagamento" },
  { value: TIPO_SOLICITACAO.RECEITA, label: "Receita" },
];

const opcoesTipoIntegracao = [
  { value: TIPO_INTEGRACAO.SIIG, label: "Não integra" },
  { value: TIPO_INTEGRACAO.CONTABILIDADE, label: "Integração parcial" },
  { value: TIPO_INTEGRACAO.SIIG_CONTABILIDADE, label: "Integração total" },
];

const opcoesTipoRenovacaoContrato = [
  { value: "A", label: "Automática" },
  { value: "M", label: "Manual" },
  { value: "N", label: "Não renovável" },
];

const opcoesTipoPeriodicidadeReajuste = [
  { value: TIPO_PERIOD_REAJUSTE.DATA_BASE, label: "Data base" },
  {
    value: TIPO_PERIOD_REAJUSTE.INTERVALO_MESES,
    label: "Intervalo de meses",
  },
];

const opcoesTipoPercentualReajuste = [
  { value: "P", label: "Previsão" },
  { value: "R", label: "Realizado" },
];

const opcoesTipoPagamento = [
  { value: TIPO_PAGAMENTO.UNICO, label: "Único" },
  { value: TIPO_PAGAMENTO.PARCELADO, label: "Parcelado" },
  { value: TIPO_PAGAMENTO.RECORRENTE, label: "Recorrente" },
];

const opcoesTipoValor = [
  { value: TIPO_VALOR.FIXO, label: "Fixo" },
  { value: TIPO_VALOR.ESTIMADO, label: "Estimado" },
];

const opcoesTipoVencimento = [
  { value: TIPO_VENCIMENTO.DIA_FIXO, label: "Dia fixo" },
  { value: TIPO_VENCIMENTO.INTERVALO_DIAS, label: "Intervalo de dias" },
];

const opcoesTipoValorNumeroDoc = [
  { value: "S", label: "Alfanumérico" },
  { value: "N", label: "Numérico" },
];

const opcoesTipoApropriacao = [
  {
    value: TIPO_APROPRIACAO.RECEITA,
    label: "Receita",
    tipo_solicitacao: TIPO_SOLICITACAO.RECEITA,
    situacao: "A",
  },
  {
    value: TIPO_APROPRIACAO.DESPESA,
    label: "Despesa",
    tipo_solicitacao: TIPO_SOLICITACAO.PAGAMENTO,
    situacao: "A",
  },
  // {
  //   value: TIPO_APROPRIACAO.ESTOQUE,
  //   label: "Estoque",
  //   tipo_solicitacao: TIPO_SOLICITACAO.PAGAMENTO,
  //   situacao: "A",
  // },
  {
    value: TIPO_APROPRIACAO.ABERTURA_LOJA,
    label: "Abertura loja",
    tipo_solicitacao: TIPO_SOLICITACAO.PAGAMENTO,
    situacao: "A",
  },
  {
    value: TIPO_APROPRIACAO.REFORMA_LOJA,
    label: "Reforma loja",
    tipo_solicitacao: TIPO_SOLICITACAO.PAGAMENTO,
    situacao: "A",
  },
];

const opcoesTipoApuracao = [
  { value: TIPO_APURACAO.SELL_IN, label: "Sell-in" },
  { value: TIPO_APURACAO.SELL_OUT, label: "Sell-out" },
  { value: TIPO_APURACAO.OUTRO, label: "Outro" },
];

//As opções inativas não são apresentadas em contrato novo, mas continuam sendo apresentadas no contrato em que estão gravadas
const opcoesTipoLancamentoContrato = [
  {
    value: TIPO_LANCAMENTO_CONTRATO.DRE,
    label: "DRE", //"(INATIVO)"
    situacao: "A", //"I"
  },
  {
    value: TIPO_LANCAMENTO_CONTRATO.FLUXO_CAIXA,
    label: "Fluxo de caixa", //"(INATIVO)"
    situacao: "A", //"I"
  },
  {
    value: TIPO_LANCAMENTO_CONTRATO.DRE_FLUXO_CAIXA,
    label: "DRE e Fluxo de caixa", //"(INATIVO)"
    situacao: "A", //"I"
  },
  // {
  //   value: TIPO_LANCAMENTO_CONTRATO.PAG_IGUAIS_DRE_FLUXO,
  //   label: "Pagamentos iguais DRE e fluxo",
  //   situacao: "A",
  // },
  // {
  //   value: TIPO_LANCAMENTO_CONTRATO.PAG_DIFERENTES_DRE_FLUXO,
  //   label: "Pagamentos diferentes DRE e fluxo",
  //   situacao: "A",
  // },
];

const opcoesTipoAnexoSolicitacao = [
  { value: TIPO_ANEXO_SOLICITACAO.COTACAO, label: "Cotação" },
  { value: TIPO_ANEXO_SOLICITACAO.CONTRATO, label: "Contrato/Acordo" },
  { value: TIPO_ANEXO_SOLICITACAO.OUTROS, label: "Outros" },
];

const opcoesTipoValorPagamento = [
  { value: TIPO_VALOR_PAG.DESCONTO, label: "Desconto" },
  { value: TIPO_VALOR_PAG.DESPESA, label: "Despesa financeira" },
  { value: TIPO_VALOR_PAG.JUROS, label: "Juros" },
  { value: TIPO_VALOR_PAG.MULTA, label: "Multa" },
];

const opcoesTipoGrupoConta = [
  { value: TIPO_GRUPO_CONTA.PAGAMENTO, label: "Pagamento" },
  { value: TIPO_GRUPO_CONTA.RECEITA, label: "Receita" },
];

const opcoesPoliticaSalarial = [
  { value: POLITICA_SALARIAL.COLABORADOR, label: "Colaborador" },
  { value: POLITICA_SALARIAL.CARGO, label: "Cargo" },
];

const opcoesTipoConta = [
  {
    value: TIPO_CONTA.RECEITA,
    label: "Receita",
  },
  {
    value: TIPO_CONTA.EMPRESTIMO,
    label: "Empréstimo",
  },
  {
    value: TIPO_CONTA.COMPRA,
    label: "Compra",
  },
  {
    value: TIPO_CONTA.DESPESA_GERAL,
    label: "Despesa geral",
  },
  {
    value: TIPO_CONTA.PAGAMENTO, //valor null tb é pagamento
    label: "Pagamento",
  },
  // {
  //   value: null, //default é PAGAMENTO
  //   label: "Pagamento",
  // },

  { value: TIPO_VALOR_PAG.DESCONTO, label: "Desconto" },
  { value: TIPO_VALOR_PAG.DESPESA, label: "Despesa financeira" },
  { value: TIPO_VALOR_PAG.JUROS, label: "Juros" },
  { value: TIPO_VALOR_PAG.MULTA, label: "Multa" },
];

const opcoesTipoContaBancaria = [
  {
    value: TIPO_CONTA_BANCARIA.CORRENTE,
    label: "Corrente",
    permite_fornecedor: "S",
  },
  {
    value: TIPO_CONTA_BANCARIA.POUPANCA,
    label: "Poupança",
    permite_fornecedor: "S",
  },
  {
    value: TIPO_CONTA_BANCARIA.GARANTIDA,
    label: "Garantida",
    permite_fornecedor: "N",
  },
];

const opcoesTipoChavePix = [
  { value: TIPO_CHAVE_PIX.CNPJ_CPF, label: "CNPJ/CPF" },
  { value: TIPO_CHAVE_PIX.EMAIL, label: "E-mail" },
  { value: TIPO_CHAVE_PIX.TELEFONE, label: "Telefone" },
  { value: TIPO_CHAVE_PIX.OUTRO, label: "Outro" },
];

const opcoesTipoRateio = [
  { value: TIPO_RATEIO.MANUAL, label: "Manual" },
  { value: TIPO_RATEIO.AUTOMATICO, label: "Automático" },
];

const opcoesFormaRateio = [
  { tipo_rateio: TIPO_RATEIO.MANUAL, value: "Q", label: "Por quantidade" },
  { tipo_rateio: TIPO_RATEIO.MANUAL, value: "V", label: "Por valor" },

  {
    tipo_rateio: TIPO_RATEIO.AUTOMATICO,
    value: "Q",
    label: "Por qtde colaborador",
  },
  { tipo_rateio: TIPO_RATEIO.AUTOMATICO, value: "V", label: "Por faturamento" },
];

const opcoesTipoAprovacao = [
  { value: TIPO_APROVACAO_SOL.INCLUSAO, label: "INCLUSÃO" },
  {
    value: TIPO_APROVACAO_SOL.ALTERACAO_PAGAMENTO,
    label: "ALTERAÇÃO PAGAMENTO",
  },
  {
    value: TIPO_APROVACAO_SOL.EFETIVACAO_CONTROLE,
    label: "CONTROLE - OPERAÇÃO REALIZADA",
  },
  {
    value: TIPO_APROVACAO_SOL.REAJUSTE_CONTRATO,
    label: "REAJUSTE CONTRATO",
  },
];

const camposLogAprovacao = [
  //Tipo "N" só para numérico com decimal
  //{ nome_campo: "tipo_documento", label: "Tipo documento", tipo_valor: "S" },
  { nome_campo: "id_tipo_documento", label: "Tipo documento", tipo_valor: "S" },
  { nome_campo: "data_vencimento", label: "Data vencimento", tipo_valor: "D" },
  { nome_campo: "valor_documento", label: "Valor documento", tipo_valor: "N" },
  { nome_campo: "valor_desconto", label: "Valor desconto", tipo_valor: "N" },
  { nome_campo: "valor_devolucao", label: "Valor devolucao", tipo_valor: "N" },
  { nome_campo: "valor_despesa", label: "Valor despesa", tipo_valor: "N" },
  { nome_campo: "valor_juros", label: "Valor juros", tipo_valor: "N" },
  { nome_campo: "valor_multa", label: "Valor multa", tipo_valor: "N" },
  { nome_campo: "valor_imposto", label: "Valor imposto", tipo_valor: "N" },
  { nome_campo: "valor_pagamento", label: "Valor pagamento", tipo_valor: "N" },
];

const camposResumoVenda = [
  {
    nome_campo: "valor_bruto",
    label: "Valor bruto",
    cpl_label: "(R$)",
    decimal: 2,
    geral: true,
    grupo: true,
  },
  {
    nome_campo: "valor_desconto",
    label: "Valor desc.",
    cpl_label: "(R$)",
    decimal: 2,
    geral: true,
    grupo: true,
  },
  {
    nome_campo: "valor_liquido",
    label: "Valor líquido",
    cpl_label: "(R$)",
    decimal: 2,
    geral: true,
    grupo: true,
  },
  {
    nome_campo: "valor_custo",
    label: "Custo",
    cpl_label: "(R$)",
    decimal: 2,
    geral: true,
    grupo: true,
  },
  {
    nome_campo: "qtde_produto",
    label: "Qtde produto",
    cpl_label: "",
    decimal: 0,
    geral: true,
    grupo: true,
  },
  {
    nome_campo: "qtde_cliente",
    label: "Qtde cliente",
    cpl_label: "",
    decimal: 0,
    geral: true,
    grupo: false,
  },
];

//Retorna a opção para FORNECEDOR NAO IDENTIFICADO
export function getFornecedorNaoIdentificado() {
  const fornecedor = {
    id: ID_FORNECEDOR_NAO_IDENTIFICADO,
    codigo: String(CODIGO_FORNECEDOR_NAO_IDENTIFICADO),
    nome: "NAO IDENTIFICADO",
    //cnpj_cpf:"00000000000000",
  };

  return {
    ...fornecedor,
    value: fornecedor.id,
    label: fn_getLabelFornecedor(fornecedor),
  };
}

//--LOAD
//Carrega as opções de situação
export function fn_loadOpcoesSituacao() {
  return opcoesSituacao;
}

//Carrega as opções de situação do contrato
export function fn_loadOpcoesSituacaoContrato(excetoCancelado = false) {
  if (excetoCancelado == true) {
    return opcoesSituacaoContrato.filter(
      (item) => item.value != SITUACAO_CONTRATO.CANCELADO,
    );
  } else {
    return opcoesSituacaoContrato;
  }
}

//Carrega as opções da situação da solicitação
export function fn_loadOpcoesSituacaoSolicitacao() {
  return opcoesSituacaoSolicitacao;
}

//Carrega as opções da situação do pagamento
export function fn_loadOpcoesSituacaoPagamento() {
  return opcoesSituacaoPagamento;
}

//Carrega as opções da situação da aprovação
export function fn_loadOpcoesSituacaoAprovacao() {
  return opcoesSituacaoAprovacao;
}

//Carrega as opções da situação da conferência
export function fn_loadOpcoesSituacaoConferencia() {
  return opcoesSituacaoConferencia;
}

//Carrega as opções da situação do reajuste
export function fn_loadOpcoesSituacaoReajuste() {
  return opcoesSituacaoReajuste;
}

//Carrega as opções de tipo perfil
export function fn_loadOpcoesTipoPerfil(permite_criar) {
  let opcoes = opcoesTipoPerfil;

  if (permite_criar) {
    opcoes = opcoesTipoPerfil.filter(
      (item) => item.permite_criar == permite_criar,
    );
  }

  return opcoes;
}

//Carrega as opções de tipo usuário
export function fn_loadOpcoesTipoUsuario(permite_criar) {
  let opcoes = opcoesTipoUsuario;

  if (permite_criar) {
    opcoes = opcoesTipoUsuario.filter(
      (item) => item.permite_criar == permite_criar,
    );
  }

  return opcoes;
}

//Carrega as opções de tipo pessoa
export function fn_loadOpcoesTipoPessoa() {
  return opcoesTipoPessoa;
}

//Carrega as opções de tipo filial
export function fn_loadOpcoesTipoFilial() {
  return opcoesTipoFilial;
}

//Carrega as opções de tipo centro custo
export function fn_loadOpcoesTipoCentroCusto(permiteCriar = null) {
  if (permiteCriar != null) {
    return opcoesTipoCentroCusto.filter(
      (tipo) => tipo.permite_criar == permiteCriar,
    );
  } else {
    return opcoesTipoCentroCusto;
  }
}

//Carrega as opções de tipo feriado
export function fn_loadOpcoesTipoFeriado() {
  return opcoesTipoFeriado;
}

//Carrega as opções de tipo solicitação
export function fn_loadOpcoesTipoSolicitacao() {
  return opcoesTipoSolicitacao;
}

//Carrega as opções de tipo grupo da conta
export function fn_loadOpcoesTipoGrupoConta() {
  return opcoesTipoGrupoConta;
}

//Carrega as opções de tipo conta
export function fn_loadOpcoesTipoConta() {
  return opcoesTipoConta;
}

//Carrega as opções de política salarial da conta
export function fn_loadOpcoesPoliticaSalarial() {
  return opcoesPoliticaSalarial;
}

//Carrega as opções de tipo integração
export function fn_loadOpcoesTipoIntegracao() {
  return opcoesTipoIntegracao;
}

//Carrega as opções de tipo renovação contrato
export function fn_loadOpcoesTipoRenovacaoContrato() {
  return opcoesTipoRenovacaoContrato;
}

//Carrega as opções de tipo periodicidade reajuste
export function fn_loadOpcoesTipoPeriodicidadeReajuste() {
  return opcoesTipoPeriodicidadeReajuste;
}

//Carrega as opções de tipo percentual reajuste
export function fn_loadOpcoesTipoPercentualReajuste() {
  return opcoesTipoPercentualReajuste;
}

//Carrega as opções de tipo pagamento
export function fn_loadOpcoesTipoPagamento() {
  return opcoesTipoPagamento;
}

//Carrega as opções de tipo valor
export function fn_loadOpcoesTipoValor() {
  return opcoesTipoValor;
}

//Carrega as opções de tipo vencimento
export function fn_loadOpcoesTipoVencimento() {
  return opcoesTipoVencimento;
}

//Carrega as opções de tipo valor número documento
export function fn_loadOpcoesTipoValorNumeroDoc() {
  return opcoesTipoValorNumeroDoc;
}

//Carrega as opções de tipo apropriação da solicitação (sem filtro informado retorna todas)
export function fn_loadOpcoesTipoApropriacao({
  situacao,
  tipo_solicitacao,
} = {}) {
  let opcoes = opcoesTipoApropriacao;

  if (situacao || tipo_solicitacao) {
    opcoes = opcoesTipoApropriacao.filter(
      (item) =>
        (!situacao || item.situacao == situacao) &&
        (!tipo_solicitacao || item.tipo_solicitacao == tipo_solicitacao),
    );
  }

  return opcoes;
}

//Carrega as opções de tipo apuração do contrato
export function fn_loadOpcoesTipoApuracao() {
  return opcoesTipoApuracao;
}

//Carrega as opções de tipo lançamento do contrato (sem informar a situação retorna todas, ativas e inativas)
export function fn_loadOpcoesTipoLancamento(situacao) {
  let opcoes = opcoesTipoLancamentoContrato;

  if (situacao) {
    opcoes = opcoesTipoLancamentoContrato.filter(
      (item) => item.situacao == situacao,
    );
  }

  return opcoes;
}

//Carrega as opções de tipo anexo da solicitação
export function fn_loadOpcoesTipoAnexoSolicitacao() {
  return opcoesTipoAnexoSolicitacao;
}

//Carrega as opções de tipo valor do pagamento
export function fn_loadOpcoesTipoValorPagamento() {
  return opcoesTipoValorPagamento;
}

//Carrega as opções de tipo conta bancária
export function fn_loadOpcoesTipoContaBancaria() {
  return opcoesTipoContaBancaria;
}

//Carrega as opções de tipo chave pix
export function fn_loadOpcoesTipoChavePix() {
  return opcoesTipoChavePix;
}

//Carrega as opções de tipo rateio
export function fn_loadOpcoesTipoRateio() {
  return opcoesTipoRateio;
}

//Carrega as opções de forma rateio
export function fn_loadOpcoesFormaRateio(tipoRateio) {
  const opcoes = opcoesFormaRateio.filter(
    (item) => item.tipo_rateio == tipoRateio,
  );
  return opcoes;
}

//Carrega as opções de tipo aprovação
export function fn_loadOpcoesTipoAprovacao() {
  return opcoesTipoAprovacao;
}

//Retorna opções Sim e Não com valor S e N
export function fn_loadOpcoesSimNao(todos = "N") {
  const opcoes = [
    { value: "S", label: "Sim" },
    { value: "N", label: "Não" },
  ];

  if (todos == "S") {
    fn_addPrimeiraOpcaoSemValor(opcoes, "TODOS");
  }
  return opcoes;
}

//Retorna opções Sim e Não com valor null e not null
export function fn_loadOpcoesSimNao_Null() {
  return [
    { value: "null", label: "Sim" },
    { value: "notnull", label: "Não" },
  ];
}

//Retorna as opções dos filtros de upload (um filtro para cada tipo de arquivo: upload_doc, upload_cpl e upload_fpg)
export function fn_loadOpcoesFiltroUpload() {
  return [
    { value: "S", label: "Com arquivo" },
    { value: "N", label: "Sem arquivo" },
  ];
}

//Retorna os campos que são logados na aprovação
export function fn_loadCamposLogAprovacao() {
  return camposLogAprovacao;
}

//Retorna os campos do resumo venda
export function fn_loadCamposResumoVenda(tipoFaturamento = "G") {
  return camposResumoVenda.filter((campo) =>
    tipoFaturamento == "G" ? campo.geral == true : campo.grupo == true,
  );
}

//Destinatários que cada tipo de notificação sempre notifica (apresentados na liberação das notificações, sem poder desmarcar)
const destinatariosFixosNotificacao = {
  [ID_TIPO_NOTIFICACAO.SOLICITACAO_REJEITADA]: ["Quem cadastrou"],
  [ID_TIPO_NOTIFICACAO.PAGAMENTO_ERRO]: [
    "Quem cadastrou",
    "Último usuário que salvou a posse",
  ],
  [ID_TIPO_NOTIFICACAO.POSSE_DOCUMENTO_PENDENTE]: ["Quem cadastrou"],
  [ID_TIPO_NOTIFICACAO.POSSE_DOCUMENTO_VENCIDA]: ["Quem cadastrou"],
};

//Retorna os destinatários fixos do tipo de notificação (lista vazia se o tipo não tiver)
export function fn_getDestinatariosFixosNotificacao(idNotificacaoTipo) {
  return destinatariosFixosNotificacao[idNotificacaoTipo] || [];
}

//Retorna as tabelas que podem ter log de alteração
export function fn_loadTabelasLogAlteracao() {
  //OBS: Valores para create, update e delete
  //"S" = Loga operação
  //"N" = Não loga operação
  //Se não informar ou infromar "0" significa que não possui log da tal operação

  return [
    //Acesso
    { nome: "usuario", descricao: "Usuário", create: "S", update: "S" },
    {
      nome: "perfil",
      descricao: "Perfil",
      create: "S",
      update: "S",
      delete: "S",
    },
    {
      nome: "acesso_tela_perfil",
      descricao: "Liberação de tela do perfil",
      create: "S",
      delete: "S",
    },
    {
      nome: "autorizacao_perfil",
      descricao: "Liberação de autorização do perfil",
      create: "S",
      delete: "S",
    },
    {
      nome: "notificacao_tipo_tenant",
      descricao: "Configuração do tipo de notificação",
      update: "S",
    },

    //Parâmetrização
    {
      nome: "parametrizacao_tenant",
      descricao: "Parametrização do cliente",
      update: "S",
    },

    //Log
    {
      nome: "log_alteracao_param",
      descricao: "Parametrização do log de alteração",
      update: "S",
    },

    //Pessoa
    {
      nome: "pessoa_juridica",
      descricao: "Pessoa jurídica",
      create: "S",
      update: "S",
    },
    {
      nome: "pessoa_endereco",
      descricao: "Endereço da pessoa",
      create: "S",
      update: "S",
      delete: "S",
    },
    {
      nome: "pessoa_contato",
      descricao: "Contato da pessoa",
      create: "S",
      update: "S",
    },
    {
      nome: "pessoa_conta_bancaria",
      descricao: "Conta bancária da pessoa",
      create: "S",
      update: "S",
    },
    { nome: "empresa", descricao: "Empresa", create: "S", update: "S" },
    { nome: "filial", descricao: "Filial", create: "S", update: "S" },
    {
      nome: "filial_atendimento",
      descricao: "Atendimento da filial (dia da semana)",
      create: "S",
      update: "S",
    },
    {
      nome: "filial_atendimento_excecao",
      descricao: "Exceção do atendimento da filial",
      create: "S",
      delete: "S",
    },
    { nome: "fornecedor", descricao: "Fornecedor", create: "S", update: "S" },
    {
      nome: "fornecedor_codigo_contabil",
      descricao: "Código contábil do fornecedor",
      create: "S",
      update: "S",
      delete: "S",
    },

    //Alçada
    {
      nome: "alcada",
      descricao: "Alçada",
      create: "S",
      update: "S",
      delete: "S",
    },
    {
      nome: "alcada_area",
      descricao: "Área da alçada",
      create: "S",
      update: "S",
      delete: "S",
    },

    //Solicitação
    { nome: "solicitacao", descricao: "Solicitação", delete: "S" },
    {
      nome: "solicitacao_pag",
      descricao: "Pagamento da solicitação",
      update: "S",
    },
    {
      nome: "solicitacao_reajuste",
      descricao: "Reajuste do contrato",
      delete: "S",
    },
    {
      nome: "solicitacao_anexo",
      descricao: "Anexo da solicitação",
      update: "S",
      delete: "S",
    },
    {
      nome: "solicitacao_pag_anexo",
      descricao: "Anexo do pagamento",
      update: "S",
      delete: "S",
    },

    //Outros
    {
      nome: "centro_custo",
      descricao: "Centro de custo",
      create: "S",
      update: "S",
    },
    {
      nome: "centro_custo_qtde_colab",
      descricao: "Qtde de colaboradores do centro de custo",
      create: "S",
      update: "S",
    },
    {
      nome: "centro_custo_codigo_contabil",
      descricao: "Código contábil do centro de custo",
      create: "S",
      update: "S",
      delete: "S",
    },
    {
      nome: "conta_tenant",
      descricao: "Conta do cliente",
      create: "S",
      update: "S",
    },
    {
      nome: "conta_tenant_codigo_contabil",
      descricao: "Código contábil da conta do cliente",
      create: "S",
      update: "S",
      delete: "S",
    },
    { nome: "setor", descricao: "Setor", create: "S", update: "S" },
    { nome: "bandeira", descricao: "Bandeira", create: "S", update: "S" },
    { nome: "area", descricao: "Área", create: "S", update: "S" },
    { nome: "feriado", descricao: "Feriado", create: "S", update: "S" },
    {
      nome: "feriado_data_movel",
      descricao: "Data do feriado móvel",
      create: "S",
      delete: "S",
    },
    {
      nome: "feriado_uf",
      descricao: "UF do feriado",
      create: "S",
      delete: "S",
    },
    {
      nome: "feriado_cidade",
      descricao: "Cidade do feriado",
      create: "S",
      delete: "S",
    },
    {
      nome: "produto_grupo",
      descricao: "Grupo de produto",
      create: "S",
      update: "S",
    },
    {
      nome: "indice_reajuste_perc",
      descricao: "Percentual do índice de reajuste",
      create: "S",
      update: "S",
    },
  ];
}

//Retorna o objeto contrato com nome do campo e valor
export function fn_getObjContrato(dadosContrato) {
  const contrato = {};

  for (const item of dadosContrato) {
    const campo = item.campo_contrato;
    contrato[campo.nome] = item.valor;
  }

  return contrato;
}

//--GET OBJ ARRAY
//Retorna o objeto Situação conforme o valor
export function fn_getSituacao(valor) {
  return opcoesSituacao.find((item) => item.value == valor);
}

//Retorna o objeto Situação do contrato conforme o valor
export function fn_getSituacaoContrato(valor) {
  return opcoesSituacaoContrato.find((item) => item.value == valor);
}

//Retorna o objeto Situação da solicitação conforme o valor
export function fn_getSituacaoSolicitacao(valor) {
  return opcoesSituacaoSolicitacao.find((item) => item.value == valor);
}

//Retorna o objeto Situação do pagamento conforme o valor
export function fn_getSituacaoPagamento(valor) {
  return opcoesSituacaoPagamento.find((item) => item.value == valor);
}

//Retorna o objeto Situação da aprovação conforme o valor
export function fn_getSituacaoAprovacao(valor) {
  return opcoesSituacaoAprovacao.find((item) => item.value == valor);
}

//Retorna o objeto Situação da conferência conforme o valor
export function fn_getSituacaoConferencia(valor) {
  return opcoesSituacaoConferencia.find((item) => item.value == valor);
}

//Retorna o objeto Situação do reajuste conforme o valor
export function fn_getSituacaoReajuste(valor) {
  return opcoesSituacaoReajuste.find((item) => item.value == valor);
}

//Retorna o objeto Tipo perfil conforme o valor
export function fn_getTipoPerfil(valor) {
  return opcoesTipoPerfil.find((item) => item.value == valor);
}

//Retorna o objeto Tipo usuário conforme o valor
export function fn_getTipoUsuario(valor) {
  return opcoesTipoUsuario.find((item) => item.value == valor);
}

//Retorna o objeto Tipo pessoa conforme o valor
export function fn_getTipoPessoa(valor) {
  return opcoesTipoPessoa.find((item) => item.value == valor);
}

//Retorna o objeto Tipo filial conforme o valor
export function fn_getTipoFilial(valor) {
  return opcoesTipoFilial.find((item) => item.value == valor);
}

//Retorna o objeto Tipo centro custo conforme o valor
export function fn_getTipoCentroCusto(valor) {
  return opcoesTipoCentroCusto.find((item) => item.value == valor);
}

//Retorna o objeto Tipo feriado conforme o valor
export function fn_getTipoFeriado(valor) {
  return opcoesTipoFeriado.find((item) => item.value == valor);
}

//Retorna o objeto Tipo solicitação conforme o valor
export function fn_getTipoSolicitacao(valor) {
  return opcoesTipoSolicitacao.find((item) => item.value == valor);
}

//Retorna o objeto Tipo integração conforme o valor
export function fn_getTipoIntegracao(valor) {
  return opcoesTipoIntegracao.find((item) => item.value == valor);
}

//Retorna o objeto Tipo renovação contrato conforme o valor
export function fn_getTipoRenovacaoContrato(valor) {
  return opcoesTipoRenovacaoContrato.find((item) => item.value == valor);
}

//Retorna o objeto Tipo periodicidade reajuste conforme o valor
export function fn_getTipoPeriodicidadeReajuste(valor) {
  return opcoesTipoPeriodicidadeReajuste.find((item) => item.value == valor);
}

//Retorna o objeto Tipo percentual reajuste conforme o valor
export function fn_getTipoPercentualReajuste(valor) {
  return opcoesTipoPercentualReajuste.find((item) => item.value == valor);
}

//Retorna o objeto Tipo pagamento conforme o valor
export function fn_getTipoPagamento(valor) {
  return opcoesTipoPagamento.find((item) => item.value == valor);
}

//Retorna o objeto Tipo valor conforme o valor
export function fn_getTipoValor(valor) {
  return opcoesTipoValor.find((item) => item.value == valor);
}

//Retorna o objeto Tipo documento conforme o valor
// export function fn_getTipoDocumento(valor) {
//   return opcoesTipoDocumento.find((item) => item.value == valor);
// }

//Retorna o objeto Tipo apropriação conforme o valor
export function fn_getTipoApropriacao(valor) {
  return opcoesTipoApropriacao.find((item) => item.value == valor);
}

//Retorna o objeto Tipo vencimento conforme o valor
export function fn_getTipoVencimento(valor) {
  return opcoesTipoVencimento.find((item) => item.value == valor);
}

//Retorna o objeto Tipo valor número documento
export function fn_getTipoValorNumeroDoc(valor) {
  return opcoesTipoValorNumeroDoc.find((item) => item.value == valor);
}

//Retorna o objeto Anexo da solicitação conforme o valor
export function fn_getTipoAnexoSolicitacao(valor) {
  return opcoesTipoAnexoSolicitacao.find((item) => item.value == valor);
}

//Retorna o objeto Tipo valor pagamento conforme o valor
export function fn_getTipoValorPagamento(valor) {
  return opcoesTipoValorPagamento.find((item) => item.value == valor);
}

//Retorna o objeto Tipo grupo conta conforme o valor
export function fn_getTipoGrupoConta(valor) {
  return opcoesTipoGrupoConta.find((item) => item.value == valor);
}

//Retorna o objeto Tipo conta conforme o valor
export function fn_getTipoConta(valor = TIPO_CONTA.PAGAMENTO) {
  return opcoesTipoConta.find((item) => item.value == valor);
}

//Retorna o objeto Política salarial da conta conforme o valor
export function fn_getPoliticaSalarial(valor) {
  return opcoesPoliticaSalarial.find((item) => item.value == valor);
}

//Retorna o objeto Tipo conta bancária conforme o valor
export function fn_getTipoContaBancaria(valor) {
  return opcoesTipoContaBancaria.find((item) => item.value == valor);
}

//Retorna o objeto Tipo chave pix conforme o valor
export function fn_getTipoChavePix(valor) {
  return opcoesTipoChavePix.find((item) => item.value == valor);
}

//Retorna o objeto Tipo rateio conforme o valor
export function fn_getTipoRateio(valor) {
  return opcoesTipoRateio.find((item) => item.value == valor);
}

//Retorna o objeto Tipo rateio conforme o valor
export function fn_getFormaRateio(tipoRateio, valor) {
  return opcoesFormaRateio.find(
    (item) => item.tipo_rateio == tipoRateio && item.value == valor,
  );
}

//Retorna o objeto Tipo aprovação conforme o valor
export function fn_getTipoAprovacao(valor) {
  return opcoesTipoAprovacao.find((item) => item.value == valor);
}

//Retorna o item com os atributos que ele já tem e acrescenta value e label sem formatação para adicionar/selecionar no select
export function fn_getItemPadrao(
  item,
  addCodigoLabel = false,
  formatacaoCodigo = 3,
) {
  if (!item) return null;

  const codigo = fn_formatarCodigo(
    item.codigo || item.numero,
    formatacaoCodigo,
  );
  const label = item.nome || item.label;

  return {
    ...item,
    value: item.id || item.value,
    label: addCodigoLabel && codigo != 0 ? codigo + " - " + label : label,
  };
}

//Retorna o item com valor zero
export function fn_getItemValorZero(label) {
  return { value: "0", label: label || "TODOS" };
}

//Retorna o item sem valor zero
export function fn_getItemSemValor(label) {
  return { value: "", label: label || "TODOS" };
}

//Retorna o item ref. a conta bancaria para adicionar/selecionar no select
export function fn_getItemContaBancaria(contaBancaria) {
  if (!contaBancaria) return null;

  return {
    ...contaBancaria,
    value: contaBancaria.id || contaBancaria.value,
    label: fn_getLabelSelContaBancaria(contaBancaria),
  };
}

//--

//--FORMAT
//Formata o código de algum model com determinada qtde de dígitos
export function fn_formatarCodigo(codigo = "0", qtde = 3) {
  return codigo ? String(codigo).padStart(qtde, "0") : "";
}
//--

//--GET - Label
//Retorna o label para o select da conta bancária
export function fn_getLabelSelContaBancaria(contaBancaria) {
  return (
    contaBancaria.banco.numero +
    " - " +
    contaBancaria.banco.nome +
    " | Ag. " +
    contaBancaria.agencia +
    " | " +
    " Conta " +
    contaBancaria.conta
  );
}

//Retorna o label do banco formatado com o número
export function fn_getLabelBanco(banco) {
  if (banco) {
    if (banco.numero) {
      return String(banco.numero).padStart(3, "0") + " - " + banco.nome;
    } else {
      return banco.nome;
    }
  }
}

//Retorna o label da filial formatado com o código
export function fn_getLabelFilial(filial) {
  if (filial) {
    if (filial.codigo) {
      return String(filial.codigo).padStart(3, "0") + " - " + filial.nome;
    } else {
      return filial.nome;
    }
  }
}

//Retorna o label do fornecedor formatado com o código
export function fn_getLabelFornecedor(fornecedor) {
  if (fornecedor) {
    if (fornecedor.codigo && fornecedor.codigo != 0) {
      return (
        String(fornecedor.codigo).padStart(6, "0") + " - " + fornecedor.nome
      );
    } else {
      return fornecedor.nome;
    }
  }
}

//Retorna o label do centro de custo formatado com o código
export function fn_getLabelCentroCusto(centro) {
  if (centro) {
    if (centro.codigo) {
      return String(centro.codigo).padStart(4, "0") + " - " + centro.nome;
    } else {
      return centro.nome;
    }
  }
}

//Retorna a descrição da situação do job
export function fn_getDescricaoSituacaoJob(job) {
  return job.situacao == "P"
    ? " Processando..."
    : job.situacao == "E"
      ? "Erro"
      : job.situacao == "I"
        ? "Inativo"
        : "Ativo";
}

//Obtém o nome do campo do tipo valor do pagamento
export function fn_getCampoTipoValorPagamento(tipoValor) {
  switch (tipoValor) {
    case TIPO_VALOR_PAG.DESCONTO:
      return "valor_desconto";
    case TIPO_VALOR_PAG.DESPESA:
      return "valor_despesa";
    case TIPO_VALOR_PAG.JUROS:
      return "valor_juros";
    case TIPO_VALOR_PAG.MULTA:
      return "valor_multa";
    default:
      "";
  }
}

//Retorna o label para o campo inf_pagamento que depende da forma de pagamento
export function fn_getLabelCampoInfPagamento(
  siglaFormaPagamento,
  abreviado = false,
) {
  let label = "";

  //Se for CHEQUE
  if (siglaFormaPagamento == SIGLA_FORMA_PAGAMENTO.CHEQUE) {
    label = abreviado ? "Num. cheque" : "Número cheque";
  }
  //Se for BOLETO
  else if (
    [SIGLA_FORMA_PAGAMENTO.BOLETO, SIGLA_FORMA_PAGAMENTO.BOLETO_DDA].includes(
      siglaFormaPagamento,
    )
  ) {
    label = abreviado ? "Num. boleto" : "Número boleto";
  }
  //Se for PIX
  else if (siglaFormaPagamento == SIGLA_FORMA_PAGAMENTO.PIX) {
    label = "Chave pix";
  }

  return label;
}

//Retorna o label para o campo conta bancária que depende da forma de pagamento
export function fn_getLabelCampoContaBancaria(siglaFormaPagamento) {
  let label = "Conta bancária";

  //Se for CHEQUE ou DÈBITO EM CONTA
  if (
    [SIGLA_FORMA_PAGAMENTO.CHEQUE, SIGLA_FORMA_PAGAMENTO.DEBITO_CONTA].includes(
      siglaFormaPagamento,
    )
  ) {
    label = "Conta bancária empresa";
  }

  return label;
}
//--

//Adicona na primeira opção um item sem valor
export function fn_addPrimeiraOpcaoSemValor(opcoes, label) {
  opcoes.unshift({
    value: "",
    label: label || "TODOS",
  });
}

//Adicona na primeira opção um item com valor zero
export function fn_addPrimeiraOpcaoValorZero(opcoes, label) {
  opcoes.unshift({
    value: "0",
    label: label || "TODOS",
  });
}

//Adicona na primeira opção um item com determinado valor
export function fn_addPrimeiraOpcaoValorX(opcoes, label, valor) {
  opcoes.unshift({
    value: valor,
    label: label || "TODOS",
  });
}

/*
 * Retorna os feriados nacionais de dia fixo para criação do tenant
 */
export function fn_getFeriadosNacionaisFixosBrasil(idTenant) {
  return [
    {
      id_tenant: idTenant,
      nome: "CONFRATERNIZAÇÃO UNIVERSAL",
      tipo: "N",
      dia_mes_fixo: "01/01",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "TIRADENTES",
      tipo: "N",
      dia_mes_fixo: "21/04",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "DIA DO TRABALHO",
      tipo: "N",
      dia_mes_fixo: "01/05",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "INDEPENDÊNCIA DO BRASIL",
      tipo: "N",
      dia_mes_fixo: "07/09",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "NOSSA SENHORA APARECIDA",
      tipo: "N",
      dia_mes_fixo: "12/10",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "FINADOS",
      tipo: "N",
      dia_mes_fixo: "02/11",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "PROCLAMAÇÃO DA REPÚBLICA",
      tipo: "N",
      dia_mes_fixo: "15/11",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "CONSCIÊNCIA NEGRA",
      tipo: "N",
      dia_mes_fixo: "20/11",
      afeta_pagamentos: "S",
      situacao: "A",
    },
    {
      id_tenant: idTenant,
      nome: "NATAL",
      tipo: "N",
      dia_mes_fixo: "25/12",
      afeta_pagamentos: "S",
      situacao: "A",
    },
  ];
}

//### FUNCOES ESPECIFICAS PARA O PROCESSO DE SOLICITACAO ###
//Verifica se a solicitação possui alguma conta  de receita
export function fn_possuiAlgumaContaReceita(selectedContas) {
  return (
    selectedContas.length > 0 &&
    selectedContas.some((conta) => conta.tipo == TIPO_CONTA.RECEITA)
  );
}

//Verifica se a solicitação possui alguma conta de pagamento
export function fn_possuiAlgumaContaPagamento(selectedContas) {
  //OBS: Conta pagamento não é só PG. Pode ter outros tipos. Só não pode ter receita
  return (
    selectedContas.length > 0 &&
    selectedContas.some((conta) => conta.tipo != TIPO_CONTA.RECEITA)
  );
}

//Verifica se a solicitação possui somente conta de receita
export function fn_possuiSomenteContaReceita(selectedContas) {
  return (
    selectedContas.length > 0 &&
    !selectedContas.some((conta) => conta.tipo != TIPO_CONTA.RECEITA)
  );
}

//Verifica se a solicitação possui somente conta de pagamento
export function fn_possuiSomenteContaPagamento(selectedContas) {
  //OBS: Conta pagamento não é só PG. Pode ter outros tipos. Só não pode ter receita
  return (
    selectedContas.length > 0 &&
    !selectedContas.some((conta) => conta.tipo == TIPO_CONTA.RECEITA)
  );
}

//Define qual é o tipo da solciitação: Receita ou Pagamento
export function fn_definirTipoSolicitacao(contas) {
  const isReceita = fn_possuiAlgumaContaReceita(contas);

  //Se existe conta do tipo Receita - É uma receita
  if (isReceita) {
    return TIPO_SOLICITACAO.RECEITA;
  }
  //Senão é um pagamento
  else {
    return TIPO_SOLICITACAO.PAGAMENTO;
  }
}

/*
 * Valida se o usuário pode aprovar/rejeitar a solicitação conforme a alçada do perfil.
 * REGRA ÚNICA utilizada pela tela Gestora (habilita os botões Aprovar/Rejeitar) e pelo backend (avaliarSolicitacao).
 * Se a regra mudar, alterar somente aqui.
 *
 * @param solicitacao: Solicitação como retorna a listagem (SolicitacaoBusiness.listar com listar_dados_contrato = "S"),
 *                     com valor_max_pag, valor_total_pag, aprovacoes (ordenadas por id) e dados_contrato
 * @param alcada: Alçada do perfil do usuário (AlcadaBusiness.findUnique), com as áreas. Nulo se o perfil não possuir alçada
 * @param idUsuario: ID do usuário que vai aprovar/rejeitar (usuário logado)
 */
export function fn_validarAlcadaAprovacao(solicitacao, alcada, idUsuario) {
  const isParcelado = solicitacao.tipo_pagamento == TIPO_PAGAMENTO.PARCELADO;

  //Dados do contrato (mesma leitura da classe Contrato do frontend)
  let contratoAcordo = null;
  let contratoSituacao = null;
  if (solicitacao.possui_contrato == "S") {
    for (const solContrato of solicitacao.dados_contrato || []) {
      if (solContrato.campo_contrato?.nome == CAMPO_CONTRATO.ACORDO.nome) {
        contratoAcordo = solContrato.valor;
      }
    }

    contratoAcordo = contratoAcordo || "N";
    contratoSituacao = solicitacao.situacao_contrato;
  }

  //Ultima aprovação
  const ultimaAp = (solicitacao.aprovacoes || []).at(-1);

  const isReaprovacaoReajuste =
    ultimaAp?.tipo == TIPO_APROVACAO_SOL.REAJUSTE_CONTRATO;

  const isReaprovacaoAltPag =
    ultimaAp?.tipo == TIPO_APROVACAO_SOL.ALTERACAO_PAGAMENTO;

  const pagReaprovacao = ultimaAp?.solicitacao_pag;

  const valorTotalPagamentos = solicitacao.valor_total_pag;
  const valorMaxPag = solicitacao.valor_max_pag;

  //Reaprovação de alteração pagamento ou de reajuste
  const valorReaprovacao = isReaprovacaoAltPag
    ? pagReaprovacao?.valor_reaprovacao
    : isReaprovacaoReajuste
      ? valorMaxPag
      : 0;

  const valorParaAlcada = isParcelado
    ? valorTotalPagamentos
    : isReaprovacaoAltPag
      ? valorReaprovacao
      : valorMaxPag;

  //Não pode aprovar se:
  //1 - Se não tem alçada cadastrada (!alcada)

  //2 - Se for contrato suspenso
  const contratoSuspenso =
    solicitacao.possui_contrato == "S" &&
    contratoSituacao == SITUACAO_CONTRATO.SUSPENSO;

  //3 - Se for solicitação de contrato e não tiver alçada de aprovação de todos os contratos
  const contratoSemAlcada =
    solicitacao.possui_contrato == "S" &&
    contratoAcordo == "N" &&
    alcada &&
    (alcada.permite_aprovar_contrato == "N" ||
      alcada.permite_aprovar_contrato == "A");

  //3 - Se for solicitação de contrato com acordo e não tiver alçada de aprovação de contrato ou acordo
  const contratoAcordoSemAlcada =
    solicitacao.possui_contrato == "S" &&
    contratoAcordo == "S" &&
    alcada &&
    alcada.permite_aprovar_contrato == "N";

  //4 - Se tiver área liberada na alçada e a área da solicitação não estiver na lista de áreas liberadas
  const areaSemAlcada =
    alcada &&
    alcada.areas?.length > 0 &&
    !alcada.areas.map((area) => area.id_area).includes(solicitacao.id_area);

  //5 - Se o valor total a pagar é maior do que o valor máximo da alçada
  const valorSemAlcada =
    alcada && Number(valorParaAlcada) > Number(alcada.valor_maximo);

  //Verifica não pode aprovar (system pode aprovar qq coisa)
  const naoPodeAprovar =
    (!alcada ||
      contratoSuspenso ||
      contratoSemAlcada ||
      contratoAcordoSemAlcada ||
      areaSemAlcada ||
      valorSemAlcada) &&
    idUsuario != ID_USUARIO_SYSTEM;

  //Motivo apresentado na tela e retornado pelo backend
  const motivo = !naoPodeAprovar
    ? null
    : contratoSuspenso
      ? "Contrato suspenso"
      : `Não possui alçada ${
          contratoSemAlcada
            ? "para contrato!"
            : contratoAcordoSemAlcada
              ? "para contrato tipo acordo"
              : areaSemAlcada
                ? "para esta área!"
                : valorSemAlcada
                  ? "para este valor!"
                  : "!"
        }`;

  return {
    naoPodeAprovar: naoPodeAprovar ? true : false,
    motivo,
    valorParaAlcada,
    contratoSuspenso: contratoSuspenso ? true : false,
    contratoSemAlcada: contratoSemAlcada ? true : false,
    contratoAcordoSemAlcada: contratoAcordoSemAlcada ? true : false,
    areaSemAlcada: areaSemAlcada ? true : false,
    valorSemAlcada: valorSemAlcada ? true : false,
  };
}

//Obtém o mês/ano ref. que será utilizado no rateio automático
export function fn_getMesAnoRateioAutomatico(dataEmissao) {
  const mesAnoEmissao = dataEmissao
    ? fn_getMesAnoData(dataEmissao)
    : fn_getMesAnoAtual();

  //O mês/ano para o rateio é o mês/ano anterior ao mês/ano da emissão
  let mesAnoRateio = fn_addMonth(mesAnoEmissao, -1);

  //Mas se o mês/ano anterior à emissão for posterior ou igual ao mês/ano atual
  if (fn_dataIsAfter(mesAnoRateio, fn_getMesAnoAtual(), true)) {
    //Utiliza o mês/ano imediatamente anterior ao atual
    mesAnoRateio = fn_addMonth(fn_getMesAnoAtual(), -1);
  }

  return mesAnoRateio;
}

//Erros do mês/ano ref. do pagamento (fn_getErroMesAnoRefPagamento)
export const ERRO_MES_ANO_REF = {
  INVALIDO: "INVALIDO",
  POSTERIOR_EMISSAO: "POSTERIOR_EMISSAO", //mês/ano ref. depois do mês/ano da emissão
  ANTERIOR_VIGENCIA: "ANTERIOR_VIGENCIA", //mês/ano ref. antes do início da vigência do contrato
};

//Confere o mês/ano ref. do pagamento com as regras da posse (usada na conferência e no backend). Retorna o erro ou null
//@mesAnoRef: MM/YYYY
//@dataEmissao: emissão do pagamento no formato DD/MM/YYYY
//@mesAnoInicioVigencia: MM/YYYY do início da vigência do contrato (sem contrato, null: não confere)
export function fn_getErroMesAnoRefPagamento(
  mesAnoRef,
  dataEmissao,
  mesAnoInicioVigencia = null,
) {
  if (!fn_validarMesAno(mesAnoRef)) {
    return ERRO_MES_ANO_REF.INVALIDO;
  }
  if (fn_dataIsAfter(mesAnoRef, fn_getMesAnoData(dataEmissao))) {
    return ERRO_MES_ANO_REF.POSTERIOR_EMISSAO;
  }
  if (
    mesAnoInicioVigencia &&
    fn_dataIsBefore(mesAnoRef, mesAnoInicioVigencia)
  ) {
    return ERRO_MES_ANO_REF.ANTERIOR_VIGENCIA;
  }

  return null;
}

//Obtém a posição (mês/ano) do rateio automático que é gravada no pagamento (solicitacao_pag.posicao_rateio) junto com o rateio
//Vazia no rateio manual e nas parcelas do parcelado sem rateio (num_pag > 1)
export function fn_getPosicaoRateioPag(pagamento, isParcelado) {
  if (pagamento?.tipo_rateio != TIPO_RATEIO.AUTOMATICO) return null;
  if (isParcelado && pagamento.num_pag != 1) return null;

  return fn_getMesAnoRateioAutomatico(pagamento.data_emissao);
}

//Verifica se as informações para realizar o rateio automático estão no sistema (fat / qtde colab)
export function fn_validarInfRateioAutomatico(
  formaRateio,
  infRateioAutomatico,
) {
  let isValido = true;

  //Se for automático por valor (fat filial) e não tiver inf. de fat. em nenhuma filial
  if (formaRateio == FORMA_RATEIO.VALOR) {
    const valores = Object.values(infRateioAutomatico.fat_filial || []);
    if (valores.length == 0 || valores.every((valor) => Number(valor) == 0)) {
      isValido = false;
    }
  }
  //Se for automático por qtde e não tiver inf. de qtde colab em nenhum centro custo
  else if (formaRateio == FORMA_RATEIO.QUANTIDADE) {
    const quantidades = Object.values(
      infRateioAutomatico.qtdes_colab_centro || [],
    );

    if (
      quantidades.length == 0 ||
      quantidades.every((quantidade) => Number(quantidade) == 0)
    ) {
      isValido = false;
    }
  }

  return isValido;
}

//Calcula o rateio automático
export function fn_calcularRateioAutomatico(
  formaRateio,
  infRateioAutomatico,
  selectedCentros,
  tipoValor, //Ex: DE, MU, JU, DF
  valoresContas,
) {
  let rateioCentrosConta = {};

  //Calcula o valor do rateio proporcional ao faturamento da filial ou qtde colaborador
  const qtdeFatPorCentro =
    (formaRateio == FORMA_RATEIO.VALOR
      ? infRateioAutomatico?.fat_filial
      : infRateioAutomatico?.qtdes_colab_centro) || {};

  //Para cada conta
  Object.entries(valoresContas).forEach(([idConta, valorConta]) => {
    //Calcula o rateio dos centros de custos
    const valoresCentros = fn_calcularRateio(
      selectedCentros,
      qtdeFatPorCentro,
      valorConta,
    );

    const valorTotalCentros = infRateioAutomatico?.mes_ano
      ? fn_calcularTotal(valoresCentros) //Number(fn_calcularTotal(valoresCentros).toFixed(2))
      : valorConta;

    const tipoValorConta =
      tipoValor &&
      typeof tipoValor === "object" &&
      Object.prototype.hasOwnProperty.call(tipoValor, idConta)
        ? tipoValor[idConta]
        : tipoValor;

    rateioCentrosConta[idConta] = {
      tipo_valor_conta: tipoValorConta || null,
      valor_conta: valorConta,
      qtdes_centros: qtdeFatPorCentro,
      valores_centros: valoresCentros,
      valor_total_centros: valorTotalCentros,
    };
  });

  return rateioCentrosConta;
}

/*
 * Calcula o valor do rateio de cada item considerando os valores base dos itens
 * para distribuir o valor a ser rateado de forma proporcional aos valores base dos itens
 */
export function fn_calcularRateio(
  selectedItens, //centros
  valoresBaseItens, //valores fat/qtde dos centros
  valorRatear,
) {
  const valoresRateioItens = {};

  //Soma apenas os itens selecionados
  const valorTotalBaseItens = selectedItens.reduce((total, item) => {
    const key = item.value || item.id || item;
    return total + Number(valoresBaseItens[key] || 0);
  }, 0);

  if (valorTotalBaseItens > 0) {
    //Para cada item
    selectedItens.forEach((item) => {
      const key = item.value || item.id || item;

      valoresRateioItens[key] = Number(
        (
          (valorRatear / valorTotalBaseItens) *
          (valoresBaseItens[key] || 0)
        ).toFixed(2),
      );
    });

    const valorTotalItens = Number(
      fn_calcularTotal(valoresRateioItens).toFixed(2),
    );

    //AJUSTA DIFERENÇA DE CENTAVOS NO RATEIO
    if (valorRatear != valorTotalItens) {
      const keyMaiorValor = fn_getChaveMaiorValor(valoresRateioItens);
      const dif = Number((valorRatear - valorTotalItens).toFixed(2));

      //soma/subtrai a diferença que pode ser positiva ou negativa (arredonda para não ficar com resíduo de ponto flutuante. Ex: 33.339999999999996)
      valoresRateioItens[keyMaiorValor] = Number(
        (valoresRateioItens[keyMaiorValor] + dif).toFixed(2),
      );
    }
  }

  return valoresRateioItens;
}

//Verifica se o pagamento não pode ter datas e valores alterados na correção da solicitação:
//conferido, cancelado ou com posse do documento.
//O pagamento com posse ainda pode ter o rateio alterado (muda com a conta e o centro) e o mês/ano ref.
export function fn_isPagamentoBloqueadoValoresCorrecao(pagamento) {
  return (
    fn_isPagamentoBloqueadoCorrecao(pagamento?.situacao) ||
    !!pagamento?.data_posse
  );
}

//Verifica se o pagamento não pode ser alterado na correção da solicitação: conferido ou cancelado
//(no conferido a correção ainda permite alterar o mês/ano ref.; o cancelado não pode ser alterado em nada)
export function fn_isPagamentoBloqueadoCorrecao(situacaoPagamento) {
  return [SITUACAO_PAGAMENTO.CONFERIDO, SITUACAO_PAGAMENTO.CANCELADO].includes(
    situacaoPagamento,
  );
}

//Verifica se o mês/ano ref. do pagamento pode ser alterado na correção da solicitação.
//Só o pagamento cancelado não pode (o conferido e o com posse podem)
export function fn_permiteAlterarMesAnoRefCorrecao(situacaoPagamento) {
  return situacaoPagamento != SITUACAO_PAGAMENTO.CANCELADO;
}

//Substitui as contas do rateio por outras
export function fn_substituirContasRateio(rateio, substituicaoContas) {
  const substituirEstrutura = (estrutura) => {
    const novaEstrutura = {};

    Object.entries(estrutura || {}).forEach(([idContaAtual, rateioConta]) => {
      const contaNova = substituicaoContas[idContaAtual];

      const idContaDestino = contaNova
        ? Number(contaNova.value)
        : Number(idContaAtual);

      novaEstrutura[idContaDestino] = {
        ...rateioConta,
        id_conta: idContaDestino,
      };
    });

    return novaEstrutura;
  };

  return {
    ...rateio,
    rateio_centros_conta: substituirEstrutura(rateio?.rateio_centros_conta),
  };
}

/*
 * Cria a pasta da solicitação, caso ainda não exista
 */
export function fn_criarPastaSolicitacao(pathSolicitacao) {
  try {
    //Cria pasta da solicitação
    fs.mkdirSync(pathSolicitacao, { recursive: true });
  } catch (error) {
    //Se o erro for falta de permissão
    if (error.code === "EACCES" || error.code === "EPERM") {
      throw new SysError(
        "Erro de permissão para criar a pasta da solicitação em uploads.",
      );
    } else {
      throw new SysError(
        `Erro ao tentar criar a pasta da solicitação em uploads: ${error.message}`,
      );
    }
  }
}

/*
 * Retorna o caminho da path da solicitação para gravar os arquivos, sem criar a pasta
 * Considera que a pasta já foi criada ao criar a solicitação.
 */
export function fn_getPathSolicitacao(pathTenant, numSolicitacao) {
  if (!pathTenant) {
    throw new SysError(
      "Path tenant não enviado para acessar os arquivos da solicitação.",
    );
  }

  const pastaTenant = path.resolve("uploads", pathTenant, "solicitacoes");
  const pathSolicitacao = path.join(pastaTenant, String(numSolicitacao));

  return pathSolicitacao;
}

//Retorna o nome do anexo da solicitação padronizado
export function fn_padronizarNomeArquivoAnexo(
  numSolicitacao,
  nomeAnexo,
  extensao,
) {
  //apesar de o front já retirar os caracteres inválidos para nome de arquivo, garante no back.
  return `num_${numSolicitacao}_anexo_${fn_removerCaracteresInvalidosNomeArquivo(nomeAnexo).trim()}.${extensao}`;
}

//Retorna o nome do arquivo do documento do pagamento padronizado
export function fn_padronizarNomeArquivoDocumento(
  numSolicitacao,
  numPag,
  extensao,
  tipoDoc,
) {
  if (!tipoDoc || tipoDoc == TIPO_ANEXO_PAGAMENTO.DOCUMENTO) {
    //documento do pagamento
    return `num_${numSolicitacao}_pag_${numPag}.${extensao}`;
  } else {
    //outros tipos de documento. Ex: Forma pagamento
    return `num_${numSolicitacao}_pag_${numPag}_${tipoDoc}.${extensao}`;
  }
}

//Nome do tipo do arquivo do pagamento no título da visualização
const TITULOS_TIPO_ARQUIVO_PAGAMENTO = {
  [TIPO_ANEXO_PAGAMENTO.DOCUMENTO]: "DOCUMENTO",
  [TIPO_ANEXO_PAGAMENTO.COMPLEMENTAR]: "DOC. COMPLEMENTAR",
  [TIPO_ANEXO_PAGAMENTO.FORMA_PAGAMENTO]: "DOC. PAGAMENTO",
};

/*
 * Retorna o título da visualização do arquivo do pagamento, a partir do nome padronizado do arquivo
 * (fn_padronizarNomeArquivoDocumento: num_500_pag_1.pdf, num_500_pag_1_FPG.pdf, num_500_pag_1_CPL.pdf).
 * Ex: "DOCUMENTO - Solicitação 500 pag 1" e, no recorrente e no parcelado, "DOCUMENTO - Solicitação 500 pag 1/3".
 * Arquivo fora do padrão (ex: anexo da solicitação): null (a tela mostra o nome do arquivo).
 * @tipoPagamento / @qtdePagamentos: da solicitação (opcionais; sem eles, sem a quantidade de pagamentos)
 * @somenteTipo: só o tipo do arquivo (ex: "DOCUMENTO"), para o painel fixo, que já tem o título da tela acima
 */
export function fn_getTituloArquivoPagamento(
  nomeArquivo,
  { tipoPagamento, qtdePagamentos, somenteTipo = false } = {},
) {
  const partes = /^num_(\d+)_pag_(\d+)(?:_([A-Za-z]+))?\.[^.]+$/.exec(
    String(nomeArquivo ?? ""),
  );

  if (!partes) {
    return null;
  }

  const [, numSolicitacao, numPag, tipoAnexo] = partes;
  const tipo =
    TITULOS_TIPO_ARQUIVO_PAGAMENTO[
      (tipoAnexo || TIPO_ANEXO_PAGAMENTO.DOCUMENTO).toUpperCase()
    ];

  if (!tipo) {
    return null;
  }

  if (somenteTipo) {
    return tipo;
  }

  const qtde =
    tipoPagamento &&
    tipoPagamento != TIPO_PAGAMENTO.UNICO &&
    Number(qtdePagamentos) > 0
      ? `/${qtdePagamentos}`
      : "";

  return `${tipo} - Solicitação ${numSolicitacao} pag ${numPag}${qtde}`;
}

// //Retorna o nome do arquivo da forma de pagamento do pagamento padronizado
// export function fn_padronizarNomeArquivoFormaPag(
//   numSolicitacao,
//   numPag,
//   extensao,
// ) {
//   return `num_${numSolicitacao}_pag_${numPag}_formaPag.${extensao}`;
// }

//Calcula o valor a pagar
export function fn_calcularValorPagarPagamento(pagamento) {
  const vDocumento = Number(pagamento.valor_documento || 0);

  const vDesconto = Number(pagamento.valor_desconto || 0);

  const vDevolucao = Number(pagamento.valor_devolucao || 0);

  const vDespesa = Number(pagamento.valor_despesa || 0);

  const vJuros = Number(pagamento.valor_juros || 0);

  const vMulta = Number(pagamento.valor_multa || 0);

  const vImpostos = Number(pagamento.valor_imposto || 0);

  //Calcula o valor a pagar
  const valorPagamento =
    vDocumento > 0
      ? vDocumento -
        (vDesconto + vDevolucao + vImpostos) +
        (vDespesa + vJuros + vMulta)
      : 0;

  return valorPagamento;
}

//Inclui informações no pagamento para realizar reajuste
export function fn_normalizarPagamentoParaReajuste(pagamento) {
  // Sequelize -> objeto puro
  const pag = pagamento?.toJSON ? pagamento.toJSON() : pagamento;

  const valoresTipoAgrup = fn_agruparTotal(
    pag.valores_tipo,
    ["tipo_valor", "id_conta"],
    "valor",
  );

  const valoresImpostosAgrup = fn_agruparTotal(
    pag.impostos,
    ["id_imposto"],
    "valor",
  );

  return {
    ...pag,

    valor_documento: Number(pag.valor_documento || 0),

    valores_tipo_array: pag.valores_tipo || [],
    valores_tipo: valoresTipoAgrup,
    valores_impostos: valoresImpostosAgrup,

    reajustes_manuais: pag.reajustes_manuais || [],
  };
}

//Criar um mapa dos reajustes alterados com chave tipo_entidade + id_entidade
function criarMapaAlteracoes(reajustesAlterados = []) {
  const mapa = {};

  reajustesAlterados.forEach((alt) => {
    mapa[`${alt.tipo_entidade}_${alt.id_entidade}`] = Number(
      alt.valor_ajustado,
    );
  });

  return mapa;
}

//Aplica o reajuste nos pagamentos
export function fn_aplicarReajuste(
  pagamentos,
  perc,
  loadReajusteManual = true,
) {
  const novosValores = {};

  pagamentos.forEach((pag) => {
    //Mapa das alterações manuais do pagamento
    const mapaAlteracoes =
      loadReajusteManual == true
        ? criarMapaAlteracoes(pag.reajustes_manuais || [])
        : {};

    //VALOR DOCUMENTO
    const valorDoc = Number(pag.valor_documento || 0);

    const valorDocReaj = Number(
      (perc != null ? valorDoc + (valorDoc * perc) / 100 : valorDoc).toFixed(2),
    );

    //DESCONTOS
    const valoresDescReajOrig = {};
    const valoresDescReaj = {};
    let valorTotalDescontoOrig = 0;
    let valorTotalDesconto = 0;
    let descontoAjustado = false;

    const descontos = (pag.valores_tipo_array || []).filter(
      (vt) => vt.tipo_valor == TIPO_VALOR_PAG.DESCONTO,
    );

    descontos.forEach((tpDesc) => {
      const valorDesc = Number(tpDesc.valor || 0);

      //Aplica reajuste percentual
      let valorDescReajOrig = valorDesc;
      if (tpDesc.conta?.permite_reajuste == "S") {
        valorDescReajOrig = Number(
          (perc != null
            ? valorDesc + (valorDesc * perc) / 100
            : valorDesc
          ).toFixed(2),
        );
      }

      //Verifica alteração manual por conta (Ex: Desconto)
      let valorDescReaj = valorDescReajOrig;
      const key = `C_${tpDesc.conta.id}`;
      if (mapaAlteracoes[key] != null) {
        //sobrescreve o reajuste do percentual pelo manual
        valorDescReaj = Number(mapaAlteracoes[key]);
        descontoAjustado = true;
      }

      //Arredonda as somas em centavos para não ficar com resíduo de ponto flutuante (Ex: 0.1 + 0.2 = 0.30000000000000004)
      valorTotalDescontoOrig = Number(
        (valorTotalDescontoOrig + valorDescReajOrig).toFixed(2),
      );
      valorTotalDesconto = Number(
        (valorTotalDesconto + valorDescReaj).toFixed(2),
      );

      valoresDescReajOrig[tpDesc.conta.id] = valorDescReajOrig;
      valoresDescReaj[tpDesc.conta.id] = valorDescReaj;
    });

    //IMPOSTOS
    const valoresImpReajOrig = {};
    const valoresImpReaj = {};
    let valorTotalImpostoOrig = 0;
    let valorTotalImposto = 0;
    let impostoAjustado = false;

    Object.entries(pag.valores_impostos || {}).map(([idImposto, valor]) => {
      const valorImp = Number(valor || 0);

      let valorImpReajOrig = Number(
        (perc != null ? valorImp + (valorImp * perc) / 100 : valorImp).toFixed(
          2,
        ),
      );

      //Verifica alteração manual por imposto
      let valorImpReaj = valorImpReajOrig;
      const key = `I_${idImposto}`;
      if (mapaAlteracoes[key] != null) {
        valorImpReaj = Number(mapaAlteracoes[key]);
        impostoAjustado = true;
      }

      valorTotalImpostoOrig = Number(
        (valorTotalImpostoOrig + valorImpReajOrig).toFixed(2),
      );
      valorTotalImposto = Number((valorTotalImposto + valorImpReaj).toFixed(2));

      valoresImpReajOrig[idImposto] = valorImpReajOrig;
      valoresImpReaj[idImposto] = valorImpReaj;
    });

    //Monta os novos valores do reajuste
    const novoPag = {
      ...pag,
      valor_documento: valorDocReaj,
      valor_desconto: valorTotalDesconto,
      valor_imposto: valorTotalImposto,
    };

    const valorPagReaj = fn_calcularValorPagarPagamento(novoPag);

    novosValores[pag.num_pag] = {
      num_pag: pag.num_pag,

      reajustes: {
        id_solicitacao_pag: pag.id,

        valores_tipo_orig: {
          [TIPO_VALOR_PAG.DESCONTO]: valoresDescReajOrig,
        },
        valores_tipo: {
          [TIPO_VALOR_PAG.DESCONTO]: valoresDescReaj,
        },

        valores_impostos_orig: valoresImpReajOrig,
        valores_impostos: valoresImpReaj,
      },

      valor_documento: valorDocReaj,

      valor_desconto_orig: valorTotalDescontoOrig,
      valor_desconto: valorTotalDesconto,
      descontoAjustado: descontoAjustado,

      valor_imposto_orig: valorTotalImpostoOrig,
      valor_imposto: valorTotalImposto,
      impostoAjustado: impostoAjustado,

      valor_pagamento: valorPagReaj,
    };
  });

  return novosValores;
}

//Retorna os dados da solicitação para gerar o hash da tabela Solicitacao
export function fn_getDadosHashSolicitacao(solicitacao) {
  return [
    solicitacao.id_tenant,
    solicitacao.id_usuario,
    fn_getDataHoraAtualSemSegundos(), //data cadastro
    solicitacao.tipo,
    solicitacao.descricao,
    solicitacao.motivo,
    solicitacao.id_empresa,
    solicitacao.id_fornecedor,
    solicitacao.id_area,
    solicitacao.nome_negociador,
    solicitacao.possui_contrato,
    solicitacao.operacao_realizada,
    solicitacao.exige_aprovacao,
    solicitacao.tipo_apropriacao,
    solicitacao.tipo_pagamento,
    solicitacao.tipo_valor_pagamento,
    solicitacao.tipo_vencimento,
    solicitacao.dia_intervalo_vencimento,
    solicitacao.dias_ant_emissao,
    solicitacao.obs_pagamento ?? "",
  ];
}

//Ordena a seleção dos centros para primeiro apresntar as opções do todos e depois os ids ordenados no log da correção
export function fn_ordenarSelecaoCentros(ids) {
  return [...ids].sort((a, b) => {
    const aEhTipo = String(a).startsWith("T");
    const bEhTipo = String(b).startsWith("T");

    if (aEhTipo && !bEhTipo) return -1;
    if (!aEhTipo && bEhTipo) return 1;

    if (aEhTipo && bEhTipo) {
      return String(a).localeCompare(String(b));
    }

    return Number(a) - Number(b);
  });
}
